import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import ClassLevelModal from './ClassLevelModal';

const ClassLevels = () => {
    
    const [isModalOpen, setIsModalOpen] = useState(false);

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [classLevels, setClassLevels] = useState([
        // Sample data (replace with actual data)
        { classLevel: 'Beginner', status: 'Active' },
        { classLevel: 'Intermediate', status: 'Deactive' },
        { classLevel: 'Advanced', status: 'Active' },
    ]);
    const [filteredClassLevels, setFilteredClassLevels] = useState(classLevels);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = classLevels.filter((level) =>
            Object.values(level).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredClassLevels(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, classLevels]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredClassLevels.length / itemsPerPage);
    const currentData = filteredClassLevels.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    const toggleStatus = (index) => {
        setClassLevels((prevLevels) =>
            prevLevels.map((level, i) =>
                i === index
                    ? { ...level, status: level.status === 'Active' ? 'Deactive' : 'Active' }
                    : level
            )
        );
    };

    const handleDelete = (index) => {
        const updatedData = currentData.filter((_, i) => i !== index);
        setClassLevels(updatedData);
    };

    return (
        <>
                <div className="oms-header">
                    <h1 className="dashboard-title">Class level</h1>

                    {/* Add Fees Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add level
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Class Levels Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Class Level</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((level, index) => (
                                    <tr key={index}>
                                        <td>{level.classLevel}</td>
                                        <td>
                                            <td>
                                                <button onClick={() => toggleStatus(index)}>
                                                    <i className={`fa ${level.status === 'Active' ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                                </button>
                                            </td>
                                        </td>
                                        <td>
                                            <button className="edit-button" onClick={() => setIsModalOpen(true)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(index)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: 'center' }}>
                                        No class levels found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>

            <ClassLevelModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default ClassLevels;
